import { DataTable } from "mantine-datatable";
import React, { Fragment, useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomPagination from "../../components/Layouts/CustomPagination";
import eventService from "../../service/event.service";
import IconEye from "../../components/Icon/IconEye";
import Breadcrump from "./Breadcrump";
import { Tab } from "@headlessui/react";

const StartListTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { event_ids } = useParams();
  const [rowData, setRowData] = useState([]);
  const [allData, setAlldata] = useState("");
  const [loading, setLoading] = useState(false);
  const [tabid, setTabid] = useState(1);
  const [sortStatus, setSortStatus] = useState({
    columnAccessor: "id",
    direction: "asc",
  });
  const eventName = location?.state;

  // Parse event_ids from URL parameter (comma-separated string)
  const eventIdsArray = useMemo(() => {
    return event_ids ? event_ids.split(',').map(id => parseInt(id.trim())) : [];
  }, [event_ids]);


  const getAllData = async () => {
    try {
      setLoading(true);

      const response = await eventService.manWomandata({ event_id: eventIdsArray });
      const result = response?.data?.data;

      setAlldata(result);
      setRowData(result?.male);
      setLoading(false);
    } catch (e) {
      console.log("e", e);
      setLoading(false);
    }
  };
  
  const handlegetBack = () => {
    navigate("/event");
  };


  const handleTabChange = (id) => {
    setTabid(id);
  };

  useEffect(() => {
    if (tabid === 1) {
      setLoading(true);
      setRowData(allData?.male);
      setLoading(false);
    } else {
      setLoading(true);
      setRowData(allData?.female);
      setLoading(false);
    }
  }, [tabid]);
  useEffect(() => {
    getAllData();
  }, [eventIdsArray]);

  return (
    <>
      <div>
        <div className="panel mt-6 event-table">
          <h5 className="font-semibold text-lg text-gray-600">
            <span
              className="cursor-pointer hover:underline"
              onClick={handlegetBack}
            >
              {eventName}
            </span>
            {" > "}
            <span>Athlete</span>

          </h5>
          <div className="flex items-center justify-center mb-4">
            <Tab.Group>
              <Tab.List className="mt-3 flex flex-wrap border-b border-white-light dark:border-[#191e3a]">
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`${selected
                          ? "text-secondary !outline-none before:!w-full"
                          : ""
                        }
                                                    before:inline-block' relative -mb-[1px] flex items-center p-5 py-3 before:absolute before:bottom-0 before:left-0 before:right-0 before:m-auto before:h-[1px] before:w-0 before:bg-secondary before:transition-all before:duration-700 hover:text-secondary hover:before:w-full`}
                      onClick={() => handleTabChange(1)}
                    >
                      Man
                    </button>
                  )}
                </Tab>
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`${selected
                          ? "text-secondary !outline-none before:!w-full"
                          : ""
                        }
                                                before:inline-block' relative -mb-[1px] flex items-center p-5 py-3 before:absolute before:bottom-0 before:left-0 before:right-0 before:m-auto before:h-[1px] before:w-0 before:bg-secondary before:transition-all before:duration-700 hover:text-secondary hover:before:w-full`}
                      onClick={() => handleTabChange(2)}
                    >
                      Woman
                    </button>
                  )}
                </Tab>
              </Tab.List>
            </Tab.Group>
          </div>
          <div className="datatables Advanced-pagination">
            <DataTable
              noRecordsText="No results match your search query"
              highlightOnHover
              className="whitespace-nowrap table-hover Advanced-pagination"
              records={rowData}
              columns={[
                {
                  title: "No.",
                  render: (record, index) => <div>{index + 1}</div>,
                },
                {
                  title: "Gender",
                  render: ({ athlete_gender }) => <div>{athlete_gender}</div>,
                },
                {
                  // accessor: "athlete_first",
                  title: "First Name",
                  // sortable: true,
                  render: ({ athlete_first }) => <div>{athlete_first}</div>,
                },
                {
                  // accessor: "athlete_last",
                  title: "Last Name",
                  // sortable: true,
                  render: ({ athlete_last }) => <div>{athlete_last}</div>,
                },
                {
                  // accessor: "athlete_yob",
                  title: "YOB",
                  // sortable: true,
                  render: ({ dob }) => <div>{dob}</div>,
                },
                {
                  // accessor: "country",
                  title: "Country",
                  // sortable: true,
                  render: ({ athlete_country_name }) => (
                    <div className="flex items-center gap-2">
                      <div>{athlete_country_name}</div>
                    </div>
                  ),
                },
                {
                  title: "Profile Photo",
                  render: ({ athlete_profile_image, athlete_first, athlete_last }) => (
                    <div>
                      {athlete_profile_image ? (
                        <img
                          src={athlete_profile_image}
                          alt={`${athlete_first || ""} ${athlete_last || ""}`}
                          style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                        />
                      ) : (
                        "-"
                      )}
                    </div>
                  ),
                },
              ]}
              // totalRecords={recordsData}
              sortStatus={sortStatus}
              onSortStatusChange={setSortStatus}
              minHeight={200}
              loading={loading}
              fetching={loading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StartListTable;
